import { Navigate } from "react-router-dom";
export default function MrvDashboard() { return <Navigate to="/mrv/pedidos" replace />; }
